<template>
  <div id="data-view">
    <dv-full-screen-container>
      <topHeader />
      <div class="searchBtn">
        <el-button type="primary" @click="openSearch">查询信息</el-button>
      </div>
      <div class="main-content">
        <!--总数据-->
        <div id="digital-flop">
          <div class="digital-flop-item" v-for="item in overAllData" :key="item.title">
            <div class="digital-flop-title">{{ item.title }}</div>
            <div class="digital-flop">
              <dv-digital-flop :config="item.number" style="width:100px;height:50px;" />
              <div class="unit">{{ item.unit }}</div>
            </div>
          </div>
          <dv-decoration-10 />
        </div>

        <div class="block-left-right-content">
          <div class="block-top-bottom-content">
            <!--未归寝-->
            <div class="block-top-content">
              <div class="unArrived">
                <div class="water-level-chart">
                  <div class="water-level-chart-title">未归寝情况</div>
                  <div class="water-level-chart-details"
                    >共计<span style="color: #d02654">{{ unArrivedData.totalCount }}</span
                    >人未归寝</div
                  >
                  <div class="chart-container">
                    <dv-water-level-pond style="border: 8px solid #d02654" :config="unArrivedConfig" />
                  </div>
                </div>
                <div style="margin-left: 20px;width: 100%;">
                  <el-row :gutter="20">
                    <el-col
                      :span="6"
                      v-for="(item, index) in unArrivedData.detailList"
                      :key="index"
                      style="display: flex;align-items: center;justify-content: center"
                    >
                      <div class="unArrivedPeople" @click="suppleSignature(item.id)">{{ item.name }}</div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <!--请假-->
            <div class="block-bottom-content">
              <div class="leave">
                <div class="water-level-chart">
                  <div class="water-level-chart-title">请假情况</div>
                  <div class="water-level-chart-details"
                    >共计<span style="color: #f46827">{{ leaveData.totalCount }}</span
                    >人请假</div
                  >
                  <div class="chart-container">
                    <dv-water-level-pond style="border: 8px solid #f46827" :config="leaveConfig" />
                  </div>
                </div>
                <div style="margin-left: 20px;width: 100%;">
                  <el-row :gutter="20">
                    <el-col
                      :span="6"
                      v-for="(item, index) in leaveData.detailList"
                      :key="index"
                      style="display: flex;align-items: center;justify-content: center"
                    >
                      <div class="leavePeople" @click="suppleSignature(item.id)">{{ item.name }}</div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
          <div id="scroll-board">
            <dv-scroll-board :config="inoutConfig" ref="scrollBoard" />
          </div>
        </div>
      </div>
    </dv-full-screen-container>
    <!--学生查询弹窗-->
    <el-dialog title="学生查询" :visible.sync="showSearch" width="60%">
      <el-form
        :model="studentTabel.where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="$refs.studentTabel.reload()"
        @submit.native.prevent
      >
        <el-row :gutter="15">
          <el-col :md="6" :sm="6">
            <el-form-item label="姓名:">
              <el-input v-model="studentTabel.where.name" placeholder="请输入姓名" />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="6">
            <el-form-item label="宿舍:">
              <el-cascader
                v-model="dorIds"
                :options="dorData"
                :props="{ expandTrigger: 'hover', value: 'id', label: 'name', children: 'childrenList' }"
                @change="handleCascaderChange"
              />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="6">
            <el-form-item label="床号:">
              <el-input v-model="studentTabel.where.bedNumber" placeholder="请输入床号" />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="6">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchStudent" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button type="primary" @click="openExport" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-data-table ref="studentTabel" :config="studentTabel" :initLoad="true" height="calc(90vh - 340px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="towerName" label="宿舍楼" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="storeyName" label="楼层" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="roomName" label="宿舍号" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="bedNumber" label="床号" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="studentName" label="学生姓名" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="inState" label="是否在宿舍" sortable="custom" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ row.inState == 0 ? '未归寝' : '已归寝' }}
            </template>
          </el-table-column>
          <el-table-column prop="leaveSate" label="是否请假" sortable="custom" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ row.leaveSate == 0 ? '未请假' : '请假中' }}
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-dialog>
    <!--选择时间-->
    <el-dialog title="时间选择" :visible.sync="showExport" width="400px">
      <el-form :model="exportDateForm" ref="exportDateForm" :rules="exportDateRules" label-width="85px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker v-model="exportDateForm.startTime" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd" />
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker v-model="exportDateForm.endTime" type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExport = false">取 消</el-button>
        <el-button type="primary" @click="exportData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import topHeader from './components/topHeader';
  import { addDormitorySign, towerSelect, studentSignExport } from '@/config/api';
  export default {
    name: 'DorDataV',
    components: {
      topHeader,
    },
    data() {
      return {
        overAllData: [], //总数据
        unArrivedData: {}, //未归寝数据
        leaveData: {}, //请假数据
        unArrivedConfig: {},
        leaveConfig: {},
        inoutConfig: {
          header: ['宿舍号', '学生姓名', '时间'],
          data: [],
          index: true,
          columnWidth: [50, 100, 100],
          align: ['center'],
          rowNum: 7,
          headerBGC: '#76abe6',
          headerHeight: 45,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)',
        },
        showSearch: false,
        studentTabel: {
          // 表格配置
          url: '/school/dormitory/sign/studentSearch',
          where: { towerId: null },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        towerId: null,
        dorData: null,
        showExport: false,
        exportDateForm: {},
        exportDateRules: {
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        },
        dorIds: [],
      };
    },
    created() {
      this.towerId = this.$route.query.towerId;
      this.studentTabel.where.towerId = this.$route.query.towerId;
      this.getDorData(this.$route.query.towerId);
      let that = this;
      if (window.EventSource) {
        let eventSource = new EventSource(`http://wwwapi.hdzxy.com/sse/subscribe/` + that.towerId);
        eventSource.onopen = function(event) {
          console.log('SSE链接成功');
        };
        eventSource.onmessage = function(event) {
          // console.log(event);
          if (event.data) {
            console.log('后端返回的数据:', JSON.parse(event.data));
            let dorData = JSON.parse(event.data);
            if (dorData.eventType == 'OVERALL') {
              // that.towerId = dorData.payload.towerId;
              // that.studentTabel.where.towerId = dorData.payload.towerId;
              that.overAllData = [
                {
                  title: '总人数',
                  number: {
                    number: [dorData.payload.totalNum],
                    content: '{nt}',
                    textAlign: 'right',
                    style: {
                      fill: '#4d99fc',
                      fontSize: 40,
                      fontWeight: 'bold',
                    },
                  },
                  unit: '人',
                },
                {
                  title: '已归寝',
                  number: {
                    number: [dorData.payload.arrivedNum],
                    content: '{nt}',
                    textAlign: 'right',
                    style: {
                      fill: '#1ed042',
                      fontSize: 40,
                      fontWeight: 'bold',
                    },
                  },
                  unit: '人',
                },
                {
                  title: '请假',
                  number: {
                    number: [dorData.payload.leavedNum],
                    content: '{nt}',
                    textAlign: 'right',
                    style: {
                      fill: '#f46827',
                      fontSize: 40,
                      fontWeight: 'bold',
                    },
                  },
                  unit: '人',
                },
                {
                  title: '未归寝',
                  number: {
                    number: [dorData.payload.unArrivedNum],
                    content: '{nt}',
                    textAlign: 'right',
                    style: {
                      fill: '#d02654',
                      fontSize: 40,
                      fontWeight: 'bold',
                    },
                  },
                  unit: '人',
                },
              ];
            } else if (dorData.eventType == 'UN_ARRIVED') {
              that.unArrivedData = dorData.payload;
              that.unArrivedConfig = {
                data: [((dorData.payload.totalCount / dorData.payload.personNum) * 100).toFixed(1)],
                shape: 'round',
                colors: ['#d02654', '#d02654'],
                waveHeight: 25,
                waveNum: 2,
              };
            } else if (dorData.eventType == 'LEAVE') {
              that.leaveData = dorData.payload;
              that.leaveConfig = {
                data: [((dorData.payload.totalCount / dorData.payload.personNum) * 100).toFixed(1)],
                colors: ['#ff8000', '#ff8000'],
                shape: 'round',
                waveHeight: 40,
                waveNum: 2,
              };
            } else if (dorData.eventType == 'IN_OUT') {
              that.inoutConfig.data.unshift([dorData.payload.roomName, dorData.payload.personName, dorData.payload.arriveTime]);
              that.$refs['scrollBoard'].updateRows(that.inoutConfig.data);
            }
          }
        };
        eventSource.onerror = (error) => {
          console.log('SSE链接失败');
        };
      }
    },
    methods: {
      // 补签
      suppleSignature(studentId) {
        let data = new FormData();
        this.$confirm('确定进行补签操作吗?', '提示', { type: 'warning' }).then(() => {
          data.append('id', studentId);
          addDormitorySign(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message.success('补签成功，等待数据刷新！');
            }
          });
        });
      },

      // 查询宿舍
      getDorData(towerId) {
        towerSelect({ id: towerId }).then((res) => {
          if (res.data.resCode == 200) {
            this.dorData = JSON.parse(JSON.stringify(res.data.data));
          }
        });
      },
      // 打开查询查询弹窗
      openSearch() {
        this.showSearch = true;
        this.$refs.studentTabel.reload({ page: { page: 1 } });
      },
      handleCascaderChange(value) {
        if (Array.isArray(value) && value.length > 0) {
          this.studentTabel.where.id = value[value.length - 1]; // 只保留最后一级 id
        }
      },
      // 查询数据
      searchStudent() {
        this.$refs.studentTabel.reload();
      },
      // 打开导出弹窗
      openExport() {
        this.showExport = true;
        this.exportDateForm = {
          startTime: null,
          endTime: null,
          id: this.towerId,
        };
      },
      // 导出数据
      exportData() {
        studentSignExport(this.exportDateForm).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>
<style lang="scss">
  #data-view {
    width: 100%;
    height: 100%;
    background-color: #0a0c17;
    color: #fff;
  }
  #dv-full-screen-container {
    background-image: url('https://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  #digital-flop {
    position: relative;
    height: 15%;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(6, 30, 93, 0.5);

    .dv-decoration-10 {
      position: absolute;
      width: 95%;
      left: 2.5%;
      height: 5px;
      bottom: 0px;
    }

    .digital-flop-item {
      width: 25%;
      height: 80%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-left: 3px solid rgb(6, 30, 93);
      border-right: 3px solid rgb(6, 30, 93);
    }

    .digital-flop-title {
      font-size: 20px;
      margin-bottom: 20px;
    }

    .digital-flop {
      display: flex;
    }

    .unit {
      margin-left: 10px;
      display: flex;
      align-items: flex-end;
      box-sizing: border-box;
      padding-bottom: 13px;
    }
  }
  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }
  .block-top-bottom-content {
    width: 70%;
    flex: 1;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
  }
  .block-top-content {
    height: 40%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-bottom-content {
    height: 40%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .unArrived,
  .leave {
    width: 100%;
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, 0.5);
    display: flex;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .water-level-chart {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-left: 20px;
  }
  .water-level-chart-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    justify-content: center;
  }

  .water-level-chart-details {
    height: 15%;
    display: flex;
    justify-content: center;
    font-size: 17px;
    align-items: flex-end;

    span {
      font-size: 35px;
      font-weight: bold;
      color: #58a1ff;
      margin: 0 5px;
      margin-bottom: -5px;
    }
  }

  .chart-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dv-water-pond-level {
    max-width: 90%;
    width: 150px;
    height: 150px;
    border: 8px solid #19c3eb;
    border-radius: 50%;

    ellipse {
      stroke: transparent !important;
    }

    text {
      font-size: 40px;
    }
  }
  .unArrivedPeople {
    width: 150px;
    background-color: rgba(208, 38, 84, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin: 15px;
    font-size: 20px;
  }
  .leavePeople {
    width: 150px;
    background-color: rgba(255, 128, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin: 15px;
    font-size: 20px;
  }
  #scroll-board {
    width: 30%;
    box-sizing: border-box;
    /*margin-left: 20px;*/
    margin-right: 20px;
    height: 78%;
    overflow: hidden;
  }
  .searchBtn {
    position: absolute;
    font-size: 20px;
    font-weight: bold;
    left: 27%;
    top: 50px;
    transform: translateX(-50%);
  }
</style>
